<div *ngIf="show" 
    class="_text-xl _flex _items-center"
    [ngClass]="{
        '_text-xl': !small,
        '_text-sm': small,
        '_center-xy-absolute' : positionAbsolute,
        '_center-xy _h-full': !positionAbsolute,
        '_flex-col': !inline
    }">
    <i class="fas fa-circle-notch fa-spin _z-20"></i>
    <span 
        *ngIf="label" 
        [ngClass]="[
            small ? '_text-sm' : '_text-lg', 
            inline ? '_ml-1' : '_mt-2']">
            {{label}}
    </span>
</div>
